import React from "react";
import { useChecklistArb } from "../../hooks/use-arb";
import { StatusBanner } from "./status-banner";

/**
 * Banner component that displays the start date denied message.
 */
export function StartDateDenied() {
  const bundle = useChecklistArb();

  const title = bundle.getMessage("Checklist-Startdate-Denied-Title");
  const description = bundle.getMessage("Checklist-Startdate-Denied-Description-Text");

  return (
    <StatusBanner
      testId="page-header-start-date-denied"
      title={title}
      description={description}
      largeViewPortImage={require("./svg/warning.svg").default}
      smallViewPortImage={require("./svg/warning.svg").default}
      iconClassName="warning-icon"
    />
  );
}
